module.exports = __webpack_public_path__ + "static/img/02.b8bd09c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/02.jpg
// module id = pi1g
// module chunks = 0